import { VISA } from '../../constants/partnering-networks';
import getNetworkInstance from '../../helpers/get-network-instance';
import orchCustomData from '../../helpers/orch-custom-data';
import getSetSRCProfiles from '../get-set-src-profiles';
/*
 * Buttonless wrapper for getSrcProfile api.
 * This is what is bound to "V" namespace for merchant to
 * call in integrated Vsb flows. Wrapper is needed to keep
 * integrated/buttonless specific logic and response handling
 * separate from getSrcProfile orch api
 */
const getSrcProfileForButtonless = data => {
  return new Promise(resolve => {
    orchCustomData.setVsbFlag(true);
    orchCustomData.setVsbButtonlessFlag(true);
    const vco = getNetworkInstance(orchCustomData, VISA);
    vco && vco.pushUpdatedVsbFlags({ isVsb: true, isVsbButtonless: true });
    getSetSRCProfiles(data).then(response => {
      resolve(response);
    });
  });
};

export default getSrcProfileForButtonless;
